import React, { useState } from 'react';
import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Link as MuiLink,
  TextField,
  Typography,
} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { toast } from 'react-toastify';
import LegalLayout from './LegalLayout';

const API_BASE = (import.meta.env.VITE_API_URL || 'https://api.baoubab.space').replace(/\/$/, '');

function ContactPage() {
  const [form, setForm] = useState({ name: '', email: '', message: '' });
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleChange = (field) => (event) => {
    setForm((prev) => ({ ...prev, [field]: event.target.value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setSent(false);

    try {
      const response = await fetch(`${API_BASE}/api/public/contact`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name: form.name.trim(),
          email: form.email.trim(),
          message: form.message.trim(),
        }),
      });

      const data = await response.json().catch(() => ({}));

      if (!response.ok) {
        throw new Error(data.message || "Impossible d'envoyer le message.");
      }

      setSent(true);
      setForm({ name: '', email: '', message: '' });
      toast.success(data.message || 'Message envoyé', { toastId: 'contact-sent' });
    } catch (error) {
      toast.error(error.message || "Impossible d'envoyer le message.", {
        toastId: 'contact-error',
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <LegalLayout title="Contact">
      <p>
        Une question sur baoubab, votre compte ou une commande ? Écrivez-nous via ce
        formulaire. Vous pouvez aussi nous joindre directement à{' '}
        <MuiLink href="mailto:bokonzibaoubab@gmail.com">bokonzibaoubab@gmail.com</MuiLink>.
      </p>

      {sent && (
        <Alert severity="success" sx={{ mb: 2 }}>
          Votre message a bien été envoyé. Nous vous répondrons rapidement.
        </Alert>
      )}

      <Box
        component="form"
        onSubmit={handleSubmit}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
          mt: 2,
          maxWidth: 520,
        }}
      >
        <TextField
          label="Nom"
          name="name"
          value={form.name}
          onChange={handleChange('name')}
          required
          fullWidth
          disabled={loading}
        />
        <TextField
          label="Email"
          name="email"
          type="email"
          value={form.email}
          onChange={handleChange('email')}
          required
          fullWidth
          disabled={loading}
        />
        <TextField
          label="Message"
          name="message"
          value={form.message}
          onChange={handleChange('message')}
          required
          fullWidth
          multiline
          minRows={5}
          disabled={loading}
        />
        <Button
          type="submit"
          variant="contained"
          disabled={loading}
          sx={{
            bgcolor: '#784e3c',
            color: '#fff',
            fontWeight: 700,
            textTransform: 'none',
            py: 1.25,
            alignSelf: 'flex-start',
            '&:hover': { bgcolor: '#5f3e2f' },
          }}
        >
          {loading ? <CircularProgress size={22} sx={{ color: '#fff' }} /> : 'Envoyer'}
        </Button>
      </Box>

      <Typography variant="body2" sx={{ mt: 4, color: '#777' }}>
        Voir aussi :{' '}
        <MuiLink component={RouterLink} to="/confidentialite">Confidentialité</MuiLink>
        {' · '}
        <MuiLink component={RouterLink} to="/conditions">Conditions</MuiLink>
        {' · '}
        <MuiLink component={RouterLink} to="/suppression-compte">Suppression de compte</MuiLink>
      </Typography>
    </LegalLayout>
  );
}

export default ContactPage;
